import CourseEnrollmentService from '../../../modules/courseEnrollment/courseEnrollmentService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'COURSEENROLLMENT_FORM'

const courseEnrollmentFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: courseEnrollmentFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await CourseEnrollmentService.find(id)
      }

      dispatch({
        type: courseEnrollmentFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: courseEnrollmentFormActions.INIT_ERROR,
      })

      dispatch(push('/course-enrollment'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: courseEnrollmentFormActions.CREATE_STARTED,
      })

      await CourseEnrollmentService.create(values)

      dispatch({
        type: courseEnrollmentFormActions.CREATE_SUCCESS,
      })

      Message.success(
        i18n('entities.courseEnrollment.create.success'),
      )

      dispatch(push('/course-enrollment'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: courseEnrollmentFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: courseEnrollmentFormActions.UPDATE_STARTED,
      })

      await CourseEnrollmentService.update(id, values)

      dispatch({
        type: courseEnrollmentFormActions.UPDATE_SUCCESS,
      })

      Message.success(
        i18n('entities.courseEnrollment.update.success'),
      )

      dispatch(push('/course-enrollment'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: courseEnrollmentFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default courseEnrollmentFormActions
